import React, { useState, useEffect } from 'react';

const Korisnici = () => {
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [formData, setFormData] = useState({ username: '', first_name: '', last_name: '', email: '', password: '' });

    const fetchUsers = () => {
        fetch('https://ecopell.ledscreen.rs/core/get-users/')
            .then(res => res.json())
            .then(data => setUsers(data));
    };

    useEffect(() => { fetchUsers(); }, []);

    const handleDelete = (id) => {
        if(window.confirm("Obriši korisnika?")) {
            fetch(`https://ecopell.ledscreen.rs/core/delete-user/${id}/`, { method: 'DELETE' })
                .then(() => fetchUsers());
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = editingUser ? '/core/update-profile/' : '/core/create-user/';
        fetch(`https://ecopell.ledscreen.rs${url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(editingUser ? { ...formData, username: editingUser.username } : formData)
        }).then(() => {
            setShowModal(false);
            setEditingUser(null);
            fetchUsers();
        });
    };

    const inputStyle = { width: '100%', padding: '10px', marginBottom: '10px', backgroundColor: '#050a1a', border: '1px solid #1a2a4a', color: 'white' };

    return (
        <div style={{ color: 'white' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <h2>Upravljanje korisnicima</h2>
                <button onClick={() => { setEditingUser(null); setFormData({}); setShowModal(true); }} style={{ padding: '10px 20px', backgroundColor: '#3366ff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                    + Novi Korisnik
                </button>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#0a132b' }}>
                <thead>
                    <tr style={{ borderBottom: '2px solid #3366ff' }}>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Korisničko ime</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Ime i Prezime</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Email</th>
                        <th style={{ padding: '12px', textAlign: 'center' }}>Akcije</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(u => (
                        <tr key={u.id} style={{ borderBottom: '1px solid #1a2a4a' }}>
                            <td style={{ padding: '12px' }}>{u.username}</td>
                            <td style={{ padding: '12px' }}>{u.first_name} {u.last_name}</td>
                            <td style={{ padding: '12px' }}>{u.email}</td>
                            <td style={{ padding: '12px', textAlign: 'center' }}>
                                <button onClick={() => { setEditingUser(u); setFormData(u); setShowModal(true); }} style={{ marginRight: '10px', background: 'none', color: '#3366ff', border: 'none', cursor: 'pointer' }}><i className="fas fa-edit"></i></button>
                                <button onClick={() => handleDelete(u.id)} style={{ background: 'none', color: '#ff4d4d', border: 'none', cursor: 'pointer' }}><i className="fas fa-trash"></i></button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                    <div style={{ backgroundColor: '#0a132b', padding: '30px', borderRadius: '10px', width: '400px', border: '1px solid #3366ff' }}>
                        <h3>{editingUser ? 'Izmeni korisnika' : 'Novi korisnik'}</h3>
                        <form onSubmit={handleSubmit}>
                            {!editingUser && <input style={inputStyle} placeholder="Korisničko ime" onChange={e => setFormData({...formData, username: e.target.value})} required />}
                            <input style={inputStyle} placeholder="Ime" value={formData.first_name || ''} onChange={e => setFormData({...formData, first_name: e.target.value})} />
                            <input style={inputStyle} placeholder="Prezime" value={formData.last_name || ''} onChange={e => setFormData({...formData, last_name: e.target.value})} />
                            <input style={inputStyle} type="email" placeholder="Email" value={formData.email || ''} onChange={e => setFormData({...formData, email: e.target.value})} />
                            <input style={inputStyle} type="password" placeholder="Lozinka" onChange={e => setFormData({...formData, password: e.target.value})} required={!editingUser} />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                                <button type="button" onClick={() => setShowModal(false)} style={{ background: 'none', color: 'white', border: 'none', cursor: 'pointer' }}>Otkaži</button>
                                <button type="submit" style={{ padding: '10px 20px', backgroundColor: 'white', color: '#0a132b', border: 'none', borderRadius: '5px', fontWeight: 'bold' }}>Sačuvaj</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Korisnici;